export default __webpack_public_path__ + "static/media/Tabl_5.230c825c.svg";